/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Portugal)
export default {
  'fabric.elements.mentions.team.meantion.highlight.close.button.tooltip': 'Dispensar',
  'fabric.elements.mentions.team.mention.highlight.description': 'Mantenha todos os utilizadores a par com apenas um clique. Ainda não tem uma equipa?',
  'fabric.elements.mentions.team.mention.highlight.description.link': 'Então crie uma.',
  'fabric.elements.mentions.team.mention.highlight.title': 'Mencionar equipa',
  'fabric.mention.error.defaultAction': 'Tente novamente dentro de alguns segundos',
  'fabric.mention.error.defaultHeadline': 'Ocorreu um erro',
  'fabric.mention.error.differentText': 'Tente introduzir um texto diferente',
  'fabric.mention.error.loginAgain': 'Tente terminar sessão e, em seguida, iniciar sessão novamente',
  'fabric.mention.noAccess.label': 'Sem acesso',
  'fabric.mention.noAccess.warning': '{name} não será notificado, uma vez que não tem acesso',
  'fabric.mention.unknow.user.error': 'Utilizador desconhecido {userId}'
};